import queryString from 'query-string';

export function getSearchParamsFromQuery(queryParams) {
  const {
    patients,
    providers,
    filterByOrderingPhysicianID,
    filterByBillingCodeID,
    filterByConnectionStatus,
  } = queryParams;

  const searchParams = {
    patients: patients || '',
    providers: providers || '',
  };

  // exclude the following from query if not in params.
  if (filterByOrderingPhysicianID) {
    searchParams.filterByOrderingPhysicianID = filterByOrderingPhysicianID;
  }

  if (filterByBillingCodeID) {
    searchParams.filterByBillingCodeID = filterByBillingCodeID;
  }

  if (filterByConnectionStatus) {
    searchParams.filterByConnectionStatus = filterByConnectionStatus;
  }

  return searchParams;
}

export function getSearchQueryString(searchQueryParams) {
  return queryString.stringify(searchQueryParams);
}



// WEBPACK FOOTER //
// ./src/views/containers/Search/searchUrlUtils.js